import { Button } from "react-bootstrap";
import {
  createNewAnalysisMethod,
  createNewGroupingFactor,
  PATCH_ARS_STATE,
  useArsContext,
} from "../contexts";

/**
 * A button to open a window for a new item
 *
 * @returns Button component
 */
export const NewItemButton = (): React.ReactNode => {
  const { state, dispatch } = useArsContext();
  if (!["operation", "groupingFactor"].includes(state.currentSidebar.view)) return null;
  /* Do not show add button when an analysisMethod is selected */
  if (state.currentSidebar.view === "operation" && state.currentSidebar.analysisMethodId)
    return null;

  /**
   * Add new item to the current sidebar view
   */
  const addItem = () => {
    if (state.currentSidebar.view === "groupingFactor") {
      const newFactor = createNewGroupingFactor("New grouping factor");
      dispatch({
        operation: PATCH_ARS_STATE,
        dataPath: "/groupingFactors/" + newFactor.id,
        value: newFactor,
      });
    } else {
      const newMethod = createNewAnalysisMethod("New analysis method");
      dispatch({
        operation: PATCH_ARS_STATE,
        dataPath: "/analysisMethods/" + newMethod.id,
        value: newMethod,
      });
    }
  };

  return (
    <Button
      id="ars-sidebar-new-item-button"
      variant="primary"
      className="w-100 mt-2"
      onClick={addItem}
    >
      Add new
      {state.currentSidebar.view === "groupingFactor" ? " grouping factor" : " analysis method"}
    </Button>
  );
};

NewItemButton.displayName = "NewItemButton";
